<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    viewBox: '0 0 32 26',
    width: 32,
    height: 26,
    color: '#FFFFFF',
  }
);

const originalWidth = 32;
const originalHeight = 26;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.33895 4.37763C1.44612 4.25793 1.57343 4.16295 1.71359 4.09815C1.85376 4.03335 2.00402 4 2.15577 4C2.30753 4 2.45779 4.03335 2.59795 4.09815C2.73812 4.16295 2.86543 4.25793 2.9726 4.37763L16.0003 18.8948L29.028 4.37763C29.1353 4.25812 29.2626 4.16332 29.4028 4.09864C29.5429 4.03396 29.6931 4.00067 29.8448 4.00067C29.9965 4.00067 30.1467 4.03396 30.2869 4.09864C30.427 4.16332 30.5544 4.25812 30.6617 4.37763C30.7689 4.49714 30.854 4.63902 30.9121 4.79517C30.9701 4.95131 31 5.11867 31 5.28768C31 5.4567 30.9701 5.62405 30.9121 5.7802C30.854 5.93635 30.7689 6.07823 30.6617 6.19774L16.8171 21.6224C16.71 21.7421 16.5826 21.837 16.4425 21.9018C16.3023 21.9666 16.1521 22 16.0003 22C15.8485 22 15.6983 21.9666 15.5581 21.9018C15.418 21.837 15.2906 21.7421 15.1835 21.6224L1.33895 6.19774C1.23151 6.07834 1.14626 5.93649 1.0881 5.78033C1.02994 5.62417 1 5.45676 1 5.28768C1 5.11861 1.02994 4.9512 1.0881 4.79504C1.14626 4.63887 1.23151 4.49703 1.33895 4.37763Z"
      :fill="props.color"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
